exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-four > div[data-v-faa9f758] {\n  width: calc(25% - 18px);\n}\n@media screen and (max-width: 760px) {\n.form-four > div[data-v-faa9f758] {\n    width: 100%;\n}\n}", ""]);

// exports
